var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "-4 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.106 6.27612L10.9466 7.11676L2.66813 15.3953H1.82749V14.5546L10.106 6.27612ZM13.3955 0.775391C13.167 0.775391 12.9295 0.866765 12.7558 1.04038L11.0837 2.71253L14.5102 6.13906L16.1824 4.46691C16.2671 4.38238 16.3343 4.28197 16.3801 4.17143C16.426 4.06089 16.4496 3.94239 16.4496 3.82272C16.4496 3.70305 16.426 3.58455 16.3801 3.47402C16.3343 3.36348 16.2671 3.26307 16.1824 3.17853L14.0442 1.04038C13.8615 0.857627 13.633 0.775391 13.3955 0.775391ZM10.106 3.69023L0 13.7962V17.2228H3.42653L13.5325 7.11676L10.106 3.69023Z",
    fill: "#5E2540"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.506de0eff04e5e5eedbdfe589c576286.svg";
export { ForwardRef as ReactComponent };